/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * Describes in what state an `Assignment` is.
 */
export const AssignmentKind = /* #__PURE__ */ parsers.exactly('normal', 'exam');
